import React from 'react';
import { useSelector } from 'react-redux';
import { useT } from 'talkr';
import OnlyOneOption from '../../components/onlyOneOption';
import steps from '../../survey/steps';
import store from '../../store';
import questionsMethods from '../../survey/questions';
import s from './index.module.scss';
import common from '../index.module.scss';

import firstAgeGroup from './img/18-29.png';
import secondAgeGroup from './img/30-39.png';
import thirdAgeGroup from './img/40-49.png';
import fourthAgeGroup from './img/50-59+.png';
import firstAgeGroupMale from './img/male-18.png';
import secondAgeGroupMale from './img/male-30.png';
import thirdAgeGroupMale from './img/male-40.png';
import fourthAgeGroupMale from './img/male-50.png';

import firstAgeGroupBothV1 from './img/bothV1-18.png';
import secondAgeGroupBothV1 from './img/bothV1-30.png';
import thirdAgeGroupBothV1 from './img/bothV1-40.png';
import fourthAgeGroupBothV1 from './img/bothV1-50.png';

import firstAgeGroupBothV2 from './img/bothV2-18.png';
import secondAgeGroupBothV2 from './img/bothV2-30.png';
import thirdAgeGroupBothV2 from './img/bothV2-40.png';
import fourthAgeGroupBothV2 from './img/bothV2-50.png';

import firstAgeFemaleRealV1 from './img/firstAgeFemaleRealV1.png';
import secondAgeFemaleRealV1 from './img/secondAgeFemaleRealV1.png';
import thirdAgeFemaleRealV1 from './img/thirdAgeFemaleRealV1.png';
import fourthAgeFemaleRealV1 from './img/fourthAgeFemaleRealV1.png';
import firstAgeMaleRealV1 from './img/firstAgeMaleRealV1.png';
import secondAgeMaleRealV1 from './img/secondAgeMaleRealV1.png';
import thirdAgeMaleRealV1 from './img/thirdAgeMaleRealV1.png';
import fourthAgeMaleRealV1 from './img/fourthAgeMaleRealV1.png';

import planManV1First from './img/planManV1_1.png';
import planManV1Second from './img/planManV1_2.png';
import planManV1Third from './img/planManV1_3.png';
import planManV1Fourth from './img/planManV1_4.png';

import firstWomenFatV1 from './img/firstWomenFatV1.png';
import secondWomenFatV1 from './img/secondWomenFatV1.png';
import thirdWomenFatV1 from './img/thirdWomenFatV1.png';
import fourthWomenFatV1 from './img/fourthWomenFatV1.png';

const images = {
	female: {
		a: {
			'18-29': firstAgeGroup,
			'30-39': secondAgeGroup,
			'40-49': thirdAgeGroup,
			'50-59+': fourthAgeGroup,
		},
		c: {
			'18-29': firstAgeGroupBothV1,
			'30-39': secondAgeGroupBothV1,
			'40-49': thirdAgeGroupBothV1,
			'50-59+': fourthAgeGroupBothV1,
		},
		d: {
			'18-29': firstAgeGroupBothV2,
			'30-39': secondAgeGroupBothV2,
			'40-49': thirdAgeGroupBothV2,
			'50-59+': fourthAgeGroupBothV2,
		},
		e: {
			'18-29': firstAgeFemaleRealV1,
			'30-39': secondAgeFemaleRealV1,
			'40-49': thirdAgeFemaleRealV1,
			'50-59+': fourthAgeFemaleRealV1,
		},
		f: {
			'18-29': firstWomenFatV1,
			'30-39': secondWomenFatV1,
			'40-49': thirdWomenFatV1,
			'50-59+': fourthWomenFatV1,
		},
		maleV1: {
			'18-29': planManV1First,
			'30-39': planManV1Second,
			'40-49': planManV1Third,
			'50-59+': planManV1Fourth,
		},
	},
	male: {
		a: {
			'18-29': firstAgeGroupMale,
			'30-39': secondAgeGroupMale,
			'40-49': thirdAgeGroupMale,
			'50-59+': fourthAgeGroupMale,
		},
		c: {
			'18-29': firstAgeGroupBothV1,
			'30-39': secondAgeGroupBothV1,
			'40-49': thirdAgeGroupBothV1,
			'50-59+': fourthAgeGroupBothV1,
		},
		d: {
			'18-29': firstAgeGroupBothV2,
			'30-39': secondAgeGroupBothV2,
			'40-49': thirdAgeGroupBothV2,
			'50-59+': fourthAgeGroupBothV2,
		},
		e: {
			'18-29': firstAgeMaleRealV1,
			'30-39': secondAgeMaleRealV1,
			'40-49': thirdAgeMaleRealV1,
			'50-59+': fourthAgeMaleRealV1,
		},
		f: {
			'18-29': firstAgeGroupMale,
			'30-39': secondAgeGroupMale,
			'40-49': thirdAgeGroupMale,
			'50-59+': fourthAgeGroupMale,
		},
		maleV1: {
			'18-29': planManV1First,
			'30-39': planManV1Second,
			'40-49': planManV1Third,
			'50-59+': planManV1Fourth,
		},
	},
};

function DefaultQuestion(props) {
	const { T } = useT();
	const { options, name } = props.step;
	const configXmas = store.getState().global.xmasConfig;
	const hideDescription = !configXmas;
	const gender = questionsMethods.getAnswers({ questionName: 'gender' }).value;
	let ageStepScreen = useSelector(state => state.global.ageStepScreen);
	const containImagesKey =
		ageStepScreen in Object.entries(images)[0][1] || ageStepScreen in Object.entries(images)[1][1];

	if (!containImagesKey) ageStepScreen = 'a';

	function actionOnClick() {
		setTimeout(() => {
			steps.navigate.forward({
				preventAction: 500,
			});
		}, 300);
	}

	return (
		<section className={`${common.step}`}>
			<div className={common.stepTitle}>{T('age')}</div>
			{hideDescription && <div className={common.stepDescription}>{T(`${name}_description`)}</div>}

			<div className={s.options}>
				{options &&
					Object.entries(options).map(option => {
						const img = images[gender][ageStepScreen][option[0]];

						return (
							<OnlyOneOption
								key={option[1].value}
								className={s.option}
								selectedStateClass={s.optionSelected}
								option={option[1]}
								questionName={name}
								actionOnClick={actionOnClick}
								disableFromFocus={!props.isThisCurrentStep}
								runOnChoose={() => {
									steps.userMovedToNextStepByClick({ byNextStep: true });
								}}
							>
								<div className={s.imageContent}>
									<img className={s.img} src={img} alt="" />
								</div>
								<div className={s.optionValue}>{option[1].value}</div>
							</OnlyOneOption>
						);
					})}
			</div>
		</section>
	);
}

function Age(props) {
	const questions = useSelector(state => state.questions.list);
	const questionName = props.stepData.name;
	const question = questions[questionName];
	const { isThisCurrentStep } = props;
	const { isCurrentStepCompleted } = props;
	const isThisCurrentStepClass = isThisCurrentStep ? s.stepSelected : '';
	const isThisStepCompletedClass = isCurrentStepCompleted ? s.stepCompleted : '';
	const horizontalDesign = useSelector(state => state.global.ageStepScreen) === 'd';

	return (
		<div
			className={`${s.step} ${isThisCurrentStepClass} ${isThisStepCompletedClass} ${horizontalDesign && s.horizontal}`}
		>
			<DefaultQuestion step={question} index={1} isThisCurrentStep={isThisCurrentStep} />
		</div>
	);
}

export default Age;
